import { render, staticRenderFns } from "./Electrico.vue?vue&type=template&id=00712a17&scoped=true"
import script from "./Electrico.vue?vue&type=script&lang=js"
export * from "./Electrico.vue?vue&type=script&lang=js"
import style0 from "./Electrico.vue?vue&type=style&index=0&id=00712a17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00712a17",
  null
  
)

export default component.exports